import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { SimulationStaffGuard } from 'app/core/auth/guards/simulation-staff.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/stats'
    {path: '', pathMatch : 'full', redirectTo: 'statistici'},

    // Redirect signed-in user to the '/stats'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'statistici'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')}
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
            {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes')}
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard, SimulationStaffGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            // Simulation day: child → room. The simulation team's only page (SimulationStaffGuard).
            {path: 'cauta-copil', loadChildren: () => import('app/modules/admin/simulation-lookup/simulation-lookup.routes')},
            {path: 'dashboard', loadChildren: () => import('app/modules/admin/dashboard/dashboard.routes')},
            {path: 'cursuri', loadChildren: () => import('app/modules/admin/courses/courses.routes')},
            {path: 'exercise-modules', loadChildren: () => import('app/modules/admin/exercise-modules/exercise-modules.routes')},
            {path: 'video-modules', loadChildren: () => import('app/modules/admin/video-modules/video-modules.routes')},
            {path: 'cursuri-de-vara', loadChildren: () => import('app/modules/admin/summer-courses/summer-courses.routes')},
            {path: 'simulari', loadChildren: () => import('app/modules/admin/simulations/simulations.routes')},
            {path: 'corecturi', loadChildren: () => import('app/modules/admin/corrections/corrections.routes')},
            // Pre-Corecturi bookmarks: 'Teme' lived at /teme until 2026-08-07.
            {path: 'teme', pathMatch: 'full', redirectTo: 'corecturi/teme'},
            {path: 'ateliere', loadChildren: () => import('app/modules/admin/workshops/workshops.routes')},
            {path: 'ateliere-de-vara', loadChildren: () => import('app/modules/admin/summer-workshops/summer-workshops.routes')},
            {path: 'grupe-plus', loadChildren: () => import('app/modules/admin/group-products/group-products.routes')},
            {path: 'feedback', loadChildren: () => import('app/modules/admin/group-feedback/group-feedback.routes')},
            {path: 'evenimente-custom', loadChildren: () => import('app/modules/admin/custom-events/custom-events.routes')},
            {path: 'orar', loadChildren: () => import('app/modules/admin/timetable/timetable.routes')},
            {path: 'setari', loadChildren: () => import('app/modules/admin/settings/settings.routes')},
            {path: 'share', loadChildren: () => import('app/modules/admin/share/share.routes')},
            {path: 'export', loadChildren: () => import('app/modules/admin/export/export.routes')},
            {path: 'marketing', loadChildren: () => import('app/modules/admin/marketing/marketing.routes')},
            {path: 'email-templates', loadChildren: () => import('app/modules/admin/email-templates/email-templates.routes')},
            {path: 'diplome', loadChildren: () => import('app/modules/admin/diplomas/diplomas.routes')},
            {path: 'fisiere', loadChildren: () => import('app/modules/admin/files/files.routes')},
            {path: 'media', loadChildren: () => import('app/modules/admin/media/media.routes')},
            {path: 'cms', loadChildren: () => import('app/modules/admin/cms/cms.routes')},
            {path: 'utilizatori', loadChildren: () => import('app/modules/admin/users/users.routes')},
            {path: 'comenzi', loadChildren: () => import('app/modules/admin/orders/orders.routes')},
            {path: 'asignari', loadChildren: () => import('app/modules/admin/assignments/assignments.routes')},
            {path: 'inscrieri', loadChildren: () => import('app/modules/admin/registrations/registrations.routes')},
            {path: 'produse-fizice', loadChildren: () => import('app/modules/admin/physical-products/physical-products.routes')},
            {path: 'linkuri-de-plata', loadChildren: () => import('app/modules/admin/link-products/link-products.routes')},
            {path: 'cupoane', loadChildren: () => import('app/modules/admin/vouchers/vouchers.routes')},
            {path: 'statistici', loadChildren: () => import('app/modules/admin/statistics/statistics.routes')},
            {path: 'raport-saptamanal', loadChildren: () => import('app/modules/admin/weekly-report/weekly-report.routes')},
            {path: 'raport-loguri', loadChildren: () => import('app/modules/admin/logs-report/logs-report.routes')},
            {path: 'coada-email', loadChildren: () => import('app/modules/admin/mail-queue/mail-queue.routes')},
            {path: 'jurnal', loadChildren: () => import('app/modules/admin/audit-timeline/audit-timeline.routes')},
            {path: 'jobs', loadChildren: () => import('app/modules/admin/jobs/jobs.routes')},
            {path: 'playground', loadChildren: () => import('app/modules/admin/playground/playground.routes')},
            {path: 'cookies', loadChildren: () => import('app/modules/admin/consent/consent.routes')},
            {path: 'documente', loadChildren: () => import('app/modules/admin/legal-documents/legal-documents.routes')},
        ]
    },
    {
        path: 'academania',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard, SimulationStaffGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            {path: 'tag-manager', loadChildren: () => import('app/modules/academania/tag-manager/tag-manager.routes')},
            {path: 'category-tag-manager', loadChildren: () => import('app/modules/academania/category-tag-manager/category-tag-manager.routes')},
            {path: 'module-exercitii', 
                children: [
                    {path: '', loadChildren: () => import('app/modules/academania/exercise-module-explorer/exercise-module-explorer.routes')},
                    {path: ':id', loadChildren: () => import('app/modules/academania/exercise-module-details/exercise-module-details.routes')},
                  ]
            },
            {path: 'lectii-video', 
                children: [
                    {path: '', loadChildren: () => import('app/modules/academania/video-module-explorer/video-module-explorer.routes')},
                    {path: ':id', loadChildren: () => import('app/modules/academania/video-module-details/video-module-details.routes')},
                  ]
            },
            {path: 'video-editor', loadChildren: () => import('app/modules/academania/video-editor/video-editor.routes')},
            {path: 'exercise-editor', loadChildren: () => import('app/modules/academania/exercise-editor/exercise-editor.routes')},
            {path: 'resurse', loadChildren: () => import('app/modules/academania/practice-module-resources/practice-module-resources.routes')},
        ]
    }
];
